import { render, staticRenderFns } from "./ErrorText.vue?vue&type=template&id=3ee1a21f"
import script from "./ErrorText.vue?vue&type=script&lang=js"
export * from "./ErrorText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee1a21f')) {
      api.createRecord('3ee1a21f', component.options)
    } else {
      api.reload('3ee1a21f', component.options)
    }
    module.hot.accept("./ErrorText.vue?vue&type=template&id=3ee1a21f", function () {
      api.rerender('3ee1a21f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/form/ErrorText.vue"
export default component.exports